import React from 'react';

type LinkProps = {
  children: React.ReactNode;
  href: string;
  className?: string;
  external?: boolean;
  onClick?: () => void;
};

export const Link: React.FC<LinkProps> = ({
  children,
  href,
  className = '',
  external = false,
  onClick,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href.startsWith('#') && !external) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        if (onClick) onClick();
      }
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <a
      href={href}
      className={`font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${className}`}
      target={external ? '_blank' : undefined}
      rel={external ? 'noopener noreferrer' : undefined}
      onClick={handleClick}
    >
      {children}
    </a>
  );
};